var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',{attrs:{"search-input":_vm.search,"label":_vm.label,"prepend-icon":_vm.prepend_icon,"append-icon":_vm.append_icon,"clearable":"","items":_vm.filteredItems},on:{"update:searchInput":function($event){_vm.search=$event},"update:search-input":function($event){_vm.search=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }